import { useImageAppear } from '~/utils/useImageAppear';
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    useImageAppear();
  });
});
